module.exports = __webpack_public_path__ + "img/chevron_down_blue.0794a5b7.svg";